import React from "react";
import "../styles/ResourcePages.css";
import BackToTop from "../components/BackToTop";
import SEO from "../components/SEO";

const PopularCourses = () => {
  const handleCounselingClick = () => {
    window.open("https://shorturl.at/uvKtH", "_blank");
  };

  const courses = [
    {
      name: "Computer Science",
      description: "Study programming, algorithms, and software development.",
      highlights: [
        "High demand",
        "Competitive salaries",
        "Global opportunities",
      ],
      specializations: ["AI/ML", "Software Engineering", "Data Science"],
    },
    {
      name: "Business Administration (MBA)",
      description:
        "Develop leadership and management skills for business success.",
      highlights: [
        "Career advancement",
        "Networking opportunities",
        "Versatile skills",
      ],
      specializations: ["Finance", "Marketing", "Entrepreneurship"],
    },
    {
      name: "Data Science",
      description: "Learn to analyze and interpret complex data sets.",
      highlights: ["Growing field", "High salaries", "Multiple industries"],
      specializations: ["Machine Learning", "Big Data", "Business Analytics"],
    },
    {
      name: "Mechanical Engineering",
      description: "Study the design and manufacturing of mechanical systems.",
      highlights: ["Technical skills", "Industry demand", "Innovation focus"],
      specializations: ["Robotics", "Automotive", "Energy Systems"],
    },
    {
      name: "Civil Engineering",
      description: "Learn to design and build infrastructure projects.",
      highlights: ["Stable career", "Public impact", "Global opportunities"],
      specializations: ["Structural", "Environmental", "Transportation"],
    },
  ];

  return (
    <div className="resource-page">
      <SEO
        title="Popular Courses for International Students | Grad4Grad"
        description="Discover the most in-demand courses for international students: Computer Science, MBA, Data Science, Engineering, and more. Get free course guidance and counseling."
        keywords="popular courses, international students, computer science, MBA, data science, engineering courses, study abroad programs, course guidance"
        image="https://grad4grad.com/logo512.png"
        url="https://grad4grad.com/popular-courses"
        type="website"
      />
      <div className="resource-hero">
        <h1>Popular Courses</h1>
        <p>Discover in-demand programs that can shape your future</p>
      </div>

      <div className="resource-content">
        <div className="resource-intro">
          <h2>Why Choose These Courses?</h2>
          <p>
            These programs are selected based on current market demand, career
            prospects, and global opportunities. Each course offers unique
            advantages for your future career.
          </p>
          <button className="cta-button" onClick={handleCounselingClick}>
            Get Free Course Guidance
          </button>
        </div>

        <div className="course-grid">
          {courses.map((course, index) => (
            <div key={index} className="course-card">
              <h3>{course.name}</h3>
              <p>{course.description}</p>
              <div className="highlights">
                <h4>Career Highlights:</h4>
                <ul>
                  {course.highlights.map((highlight, idx) => (
                    <li key={idx}>{highlight}</li>
                  ))}
                </ul>
              </div>
              <div className="specializations">
                <h4>Popular Specializations:</h4>
                <ul>
                  {course.specializations.map((spec, idx) => (
                    <li key={idx}>{spec}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="counseling-cta">
          <h2>Need Help Choosing Your Course?</h2>
          <p>
            Book a <strong>FREE</strong> one-on-one counseling session with our
            expert counselors. They'll help you select the right course based on
            your interests, skills, and career goals. Our guidance is completely
            free - no hidden charges!
          </p>
          <button className="cta-button" onClick={handleCounselingClick}>
            Book Your Free Counseling Session
          </button>
        </div>
      </div>
      <BackToTop />
    </div>
  );
};

export default PopularCourses;
